import SessionEventProto from "../session-event-proto"

export default class SessionEventLoadOlder extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent);
    }

    process() {
        gd.session.events.addMany(this.data);

        // console.log("debug events")
        // gd.session.events.debug();
    }
}